import { useState } from 'react';
import { Pill } from '../pill';
import { styles } from '../../constants';

const pillStyle = {
  fontWeight: 'bold',
  backgroundColorx: '#fff',
  border: '1px solid #ddd',
  color: '#555',
  position: 'relative',
  top: 1,
};

export const TableFromObject = ({ obj, ...props }) => {
  let { percent, headerStyle, cellStyle, style } = props;
  headerStyle ||= {};
  percent ||= 20;

  const nodes = Object.keys(obj || {}).map((key, idx) => {
    const val = obj[key];

    const maybeLink = (it) => {
      if (it.startsWith('http')) {
        return (
          <a href={it} target="_blank">
            {it}
          </a>
        );
      } else {
        return it;
      }
    };

    const renderArrayChild = (it) => {
      if (typeof it == 'string') {
        return maybeLink(it);
      } else if (typeof it == 'object' && !props.noRecurse) {
        return (
          <TableFromObject
            noRecurse
            obj={it}
            {...props}
            style={{ ...props.style, border: '1px solid #d0d0d0', margin: 0 }}
          />
        );
      } else {
        return JSON.stringify(it);
      }
    };

    const s = (v) => {
      if (typeof v == 'string') {
        return maybeLink(v);
      } else if (v === null || v === undefined) {
        return '';
      } else if (Array.isArray(val)) {
        return (
          <ul style={{ margin: 0, padding: 0, marginLeft: 15 }}>
            {val.map((it) => (
              <li>{renderArrayChild(it)}</li>
            ))}
          </ul>
        );
      } else if (typeof v == 'object') {
        if (props.noRecurse) {
          return JSON.stringify(v);
        } else {
          return (
            <TableFromObject obj={v} {...props} style={{ ...props.style, border: '1px solid #d0d0d0', margin: 0 }} />
          );
        }
      } else {
        return `${v}`;
      }
    };

    const y = (v) => {
      if (typeof v == 'object') {
        return {
          padding: 0,
        };
      } else {
        return {};
      }
    };

    const ser = s(val);
    const extraStyles = y(val);

    const background = idx % 2 == 1 ? '#f3f3f3' : '#fff';
    return (
      <div
        key={key}
        style={{ display: 'flex', alignItems: 'flex-start', padding: '4px 8px', background, ...cellStyle }}
      >
        <div style={{ width: `${percent}%`, fontSize: 13, ...cellStyle, ...headerStyle }}>
          <b>{key}</b>
        </div>
        <div
          style={{ width: `${100 - percent}%`, fontSize: 13, overflowWrap: 'anywhere', ...cellStyle, ...extraStyles }}
        >
          {ser}
        </div>
      </div>
    );
  });

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', ...style }}>{nodes}</div>
    </div>
  );
};
